import { render, staticRenderFns } from "./StrOccupationDataTableSelect.vue?vue&type=template&id=05d68306&scoped=true&"
import script from "./StrOccupationDataTableSelect.vue?vue&type=script&lang=js&"
export * from "./StrOccupationDataTableSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d68306",
  null
  
)

export default component.exports